export default "__VITE_ASSET__ieukyuik__"